import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ScreeningApiService {
  private static readonly URL = environment.screeningApi;

  constructor(private http: HttpClient) {}

  getLabelsPDF(packageIds: number[]) {

    const token = localStorage.getItem('ls.token').replace(/"/g, '');
    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      const codigos = {
        codigos: packageIds.map((id) => "" + id),
      };

      return this.http.post(`${ScreeningApiService.URL}/freedom/etiquetas/download`, codigos, {
        headers,
        observe: "response",
        responseType: "arraybuffer"
      }
      );
    }

  }

  getLabelsEmMassaPDF(clienteId: number) {
    const token = localStorage.getItem('ls.token').replace(/"/g, '');
    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      return this.http.get(
        `${ScreeningApiService.URL}/freedom/gerarEtiquetasPendentes/cliente/${clienteId}`,
        {
          headers,
          observe: "response",
          responseType: "arraybuffer",
        }
      );
    }
  }
}
